import React from 'react';
import { SvgProps } from '../../../types/svg';

const ErrorImage = ({ width, height }: SvgProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 149 140" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M90.2278 30.85H58.2578L69.4978 3.22C70.3678 1.07 72.3078 0 74.2378 0C76.1678 0 78.1078 1.07 78.9778 3.22L90.2278 30.85Z"
        fill="url(#paint0_linear_11594_4545)"
      />
      <path
        d="M115.326 92.5602H33.1562L45.7062 61.7002H102.766L115.326 92.5602Z"
        fill="url(#paint1_linear_11594_4545)"
      />
      <path d="M127.879 123.75H20.6094L33.1594 92.5596H115.329L127.879 123.75Z" fill="#B2B2B2" />
      <path d="M102.771 61.6996H45.7109L58.2609 30.8496H90.2309L102.771 61.6996Z" fill="#B2B2B2" />
      <path
        d="M140.72 140H8.28C3.98 140 0.5 136.37 0.5 131.89C0.5 127.41 3.98 123.78 8.28 123.78H140.72C145.02 123.78 148.5 127.41 148.5 131.89C148.5 136.37 145.02 140 140.72 140Z"
        fill="url(#paint2_linear_11594_4545)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_11594_4545"
          x1="58.2594"
          y1="15.4262"
          x2="90.2248"
          y2="15.4262"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CBCDD1" />
          <stop offset="1" stopColor="#E4E5EA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_11594_4545"
          x1="33.1555"
          y1="77.1312"
          x2="115.326"
          y2="77.1312"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CBCDD1" />
          <stop offset="1" stopColor="#E4E5EA" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_11594_4545"
          x1="0.5"
          y1="131.894"
          x2="148.5"
          y2="131.894"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CBCDD1" />
          <stop offset="1" stopColor="#E4E5EA" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ErrorImage;
